module.exports = __webpack_public_path__ + "static/img/rage-strike-market-scaled@2x.aded1c4a.png";